'use client'

import { tagCMSBlock } from '@/helpers/layout'
import { cx } from 'cva'
import type { Variants } from 'motion/react'
import { motion } from 'motion/react'
import type { FC, PropsWithChildren } from 'react'
import { useState } from 'react'
import { Corridor } from '../atoms/Corridor'
import { ControlTabHeader } from '../molecules/ControlTabHeader'

export type TabType = PropsWithChildren<{
	title: string
}>

export type TabsBlockProps = {
	tabs: TabType[]
}

const tabVariants: Variants = {
	hidden: {
		opacity: 0,
		y: -5,
	},
	visible: {
		opacity: 1,
		y: 0,
	},
}

export const TabsBlock: FC<TabsBlockProps> = ({ tabs }) => {
	const [activeTab, setActiveTab] = useState(0)

	return (
		<section className={cx(tagCMSBlock(['component']), 'overflow-hidden')}>
			<Corridor>
				<ControlTabHeader tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
			</Corridor>
			{tabs.map((tab, index) => (
				<motion.div
					aria-hidden={index !== activeTab}
					initial="hidden"
					animate={index === activeTab ? 'visible' : 'hidden'}
					variants={tabVariants}
					transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
					key={tab.title || index}
					className="mt-xl"
					aria-labelledby={`tab-${index}-button`}
					id={`tab-${index}-content`}
				>
					{index === activeTab ? tab.children : null}
				</motion.div>
			))}
			{/* {tabs[activeTab] && (
				<AnimatePresence mode="wait">
					<motion.div
						key={activeTab}
						initial={{ opacity: 0, y: -5 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -5 }}
						transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
						className="mt-xl"
					>
						{tabs[activeTab].children}
					</motion.div>
				</AnimatePresence>
			)} */}
		</section>
	)
}
